/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'

class About extends PureComponent {
	render() {
		return (
			<div>
				<img alt="introduction1" src={require('./images/business1.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction2" src={require('./images/business2.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction3" src={require('./images/business3.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction4" src={require('./images/business4.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction5" src={require('./images/business5.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction6" src={require('./images/business6.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction7" src={require('./images/business7.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction8" src={require('./images/business8.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business9.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business10.png')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business11.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business12.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business13.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="introduction9" src={require('./images/business14.jpg')} style={{display: 'block', width: '100%'}}/>
			</div>
		)
	}
}

export default About


// WEBPACK FOOTER //
// ./src/Business.js